import { Component, OnInit, Inject,ChangeDetectorRef } from '@angular/core';
import { GtConfig, GtInformation, GtOptions} from '@angular-generic-table/core';
import { Output, EventEmitter, ViewChild } from '@angular/core';
import { CustomRowComponent } from '../custom-row/custom-row.component';
import { GenericTableComponent } from '@angular-generic-table/core';
import 'rxjs/add/operator/map';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { SelectedQnrService } from '../shared/services/selected-qnr.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'rxjs/Rx';
import { TabsDataService } from '../shared/services/tabs-data.service';
import { ChangePlanModalComponent } from "../change-plan-modal/change-plan-modal.component";
import { VideoDialogComponent } from "../video-dialog/video-dialog.component";
import { UserTooltipComponent } from "./user-tooltip.component";
import { PlanUpgrageDialogComponent } from "../plan-upgrage-dialog/plan-upgrage-dialog.component";
import { ShowToastyService } from "../shared/services/showToastyService";
import { ActivatedRoute, Router } from '@angular/router';
import { superAdminService } from 'app/shared/services/superAdminService';

var Questions: any[];
var surveyData: any;
var showDetails: boolean;
var imageQues: any;

@Component({
  selector: 'app-data-surveys',
  templateUrl: './data-surveys.component.html',
  styleUrls: ['./data-surveys.component.css']
})
export class DataSurveysComponent implements OnInit {

  @ViewChild(GenericTableComponent)
  @Output() data = new EventEmitter();

  public configObject: GtConfig<any>;
  adminID = '';
  subformsIDs: any[] = [];
  ConfigOptions: GtOptions = {lazyLoad: true ,stack:false, highlightSearch:true, rowSelection:false,csvDelimiter:','};
  @ViewChild(GenericTableComponent)
  private myTable: GenericTableComponent<any, CustomRowComponent>;
  searchTerms ;
  // public surveyID = '3545884524204712030';
  selectQnr = 'No survey selected';
  selectedOption = 'Select options';
  qnrList = [];
  showLoader: boolean;
  showleftPanelLoader: boolean ;
  noQnrSelected: boolean;
  noDataCollected: boolean;
  disable_button: boolean;
  disable_button_map: boolean;
  fileName = " ";
  downloadFilePath = " ";
  modalScrollDistance = 10;
  noOfRowsAtATime: number;
  subscriptionEndedMessage:string = '';
  Questions = [];
  selectedQues = 'Select Column';
  versions = [];
  numVersionResponses = [];
  selectedVersion = 'Select Version';
  subformVersions = [];
  selectedsubformVersion = 'Select sub-form Version';
  selectedSubForm;

  //variables for filters
  optionsArray = [];
  optionsFilter: boolean = false;
  rangeFilter: boolean = false;
  minValue ;
  maxValue ;
  noDataForSelectedVersion = false;
  selecetedForm = 0;
  loaderOfDropdown: boolean = false;

  displayedColumns: string[] = ['sno', 'version', 'date', 'surveyor'];
  dataSource : PeriodicElement[] = [
  {sno: '1', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  {sno: '2', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  {sno: '3', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  {sno: '4', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  {sno: '5', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  {sno: '6', version: 'V1', date: '12/12/2022', surveyor: 'Person1'},
  ];
  enableFilter = false;
  userHeader: string;
  companyName:string;
  superAdmin;
  switchOrgList:{orgName:string,superAdminID:string}[]=[];

  constructor(public dialog: MatDialog, private restApiService: RestApiService, 
    private selectedQnrService: SelectedQnrService, private tabsDataService: TabsDataService, 
    private showToastyService:ShowToastyService, private route:ActivatedRoute,
    private router:Router, private superAdminService: superAdminService) {
    this.selectedQnrService.getSubForm.subscribe(data => {
      if(data)
      {
        this.getSubFormData({"qID" : data.id}, data["groupId"]);
      }
    });
    Questions = [];
    showDetails = true;
    imageQues = -1;
    this.configObject = {
      fields: [],
      settings: [],
      data: []
    };
    this.configObject.info = {
      pageCurrent: 1,
      pageNext: 2,
      pagePrevious: null,
      pageTotal: 10,
      recordLength: 10,
      recordsAll: 100,
      recordsAfterFilter: 100,
      recordsAfterSearch: 13
    };
    this.noOfRowsAtATime = 10;
    this.route.queryParams.subscribe(query=>{
      if(query && query.qnr){
        const qnr= JSON.parse(query.qnr);
        this.router.navigate([], {
          queryParams: {
            'qnr': null,
          },
          queryParamsHandling: 'merge'
        });
        this.getSurveyData(qnr,'MainFormSelection');
      }
    })
    this.userHeader = localStorage.getItem("user_name_header");
    this.companyName = localStorage.getItem('companyName');

    if (this.superAdminService.hasData()) {
      this.superAdmin = this.superAdminService.getData();
    } else {
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.superAdmin = true;
            this.superAdminService.setData(this.superAdmin);
          }
          else {
            this.superAdmin = false;
            this.superAdminService.setData(this.superAdmin);
          }
        });
    }
  }

  analyzeData(){
    const qnr= this.selectedQnrService.getQnr();
    this.router.navigate(['./data-analysis'],{
      queryParams:{
        'qnr':JSON.stringify(qnr)
      },
      queryParamsHandling: 'merge'
    })
  }

  goToSurveys(){
    this.router.navigate(['./questionnaires']);
  }
  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  show : string = "show";

  previewToggleClicked(noUse : string){
    if(this.show == 'show'){
      this.show = 'hide';
    }else{
      this.show = 'show';
    }
  }

  ngOnInit() {

    this.disable_button = true;
    this.disable_button_map = true;
    this.getQnrList();
    this.configObject.info = {
      pageCurrent: 1,
      pageNext: 2,
      pagePrevious: null,
      pageTotal: 10,
      recordLength: 10,
      recordsAll: 100,
      recordsAfterFilter: 100,
      recordsAfterSearch: 13
    };
    let qnr = this.selectedQnrService.getQnr();
    if (qnr) {
        this.getSurveyData(qnr, this.selectedQnrService.getSelectionType());
    }
    else {
      this.showLoader = false;
      this.showleftPanelLoader = false;
      this.versions = [];
      this.numVersionResponses = [];
      this.subformVersions = [];
      this.noQnrSelected = true;
      this.noDataCollected = false;
    }
    this.switchOrgList = this.restApiService.getSwitchOrgList();
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      this.goToSurveys();
    }
  }
  // public showFilters = function (){
  //   let dialogRef = this.dialog.open(FiltersDialogComponent, {
  //     width: "51%",
  //     height: "65%",
  //     data : Questions
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log( this.selectedQuesIndex + ' '+this.filterFields + ' ' +this.operation);
  //   });
  // }

  showDownloadDialog(){
    let data={
      versions:this.versions,
      selectedVersion:this.selectedVersion,
      selectedSurvey: this.selectQnr,
      subformsIDs: this.subformsIDs,
      numVersionResponses: this.numVersionResponses
    }
    let dialogRef = this.dialog.open(DownloadDialogComponent, {
      width: '800px',
      height: '400px',
      data : data
    });
  }

  public createCSV = function () {
    let qnr = this.selectedQnrService.getQnr();
    let formsList:any[] = [qnr.qID];
    if(Boolean(qnr.child_group)){
      formsList = formsList.concat(qnr.child_group);
    }
    let adminId = [qnr.adminID];
    if(this.subformsIDs){
      adminId = [];
      let newObj: {parentAdminId:string,parentId:string,adminId:string,
      qId:string}[]=[];
      this.subformsIDs.forEach(element => {
        newObj.push({parentAdminId:element.updatedBy, parentId:element.parent_group,
        adminId: element.adminID, qId : element.qID});
      });
      // getting the first element.
      let parentAdded = false;
      formsList.forEach(ids=>{
        newObj.forEach(data=>{
          if(ids== data.parentId && !parentAdded){
            adminId.push(this.selectedQnrService.getQnr().adminID);
            parentAdded = true;
          }
          else if(!adminId.includes(ids) && ids == data.qId){
            adminId.push(data.adminId)
          }
        })
      })
    }
    this.restApiService.getExcelFile(formsList,adminId,qnr.surveyName,null).subscribe(
      result => {
        let a = document.createElement('a');
        a.href = result;
        a.target = '_blank';
        a.download = 'data.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
  };

  public mapDisplay = function () {
    let dialogRef = this.dialog.open(MapDialogComponent, {
      width: '80%',
      height: '92%',
      data : this.selectedVersion
    });
  };

  searchInTable(searchTerm){
    this.searchTerms = searchTerm;
    this.myTable.gtSearch(searchTerm);
  }

  applyFilter(selected_column) {
    let values = [];
    if (this.rangeFilter) {
      if (!this.minValue) {
        let ele = document.getElementById('minValue');
        ele.classList.add('errValue');
        return;
      }
      else {
        let ele = document.getElementById('minValue');
        ele.classList.contains('errValue') ? ele.classList.remove('errValue') : '';
      }
      if (!this.maxValue || !(parseInt(this.minValue) <= parseInt(this.maxValue))) {
        let ele = document.getElementById('maxValue');
        ele.classList.add('errValue');
        return;
      }
      else {
        let ele = document.getElementById('maxValue');
        ele.classList.contains('errValue') ? ele.classList.remove('errValue') : '';
      }
      this.selectedOption = this.minValue + " : " + this.maxValue;
      if(this.selectedSubForm){
        this.getParticularVersionSubForms(selected_column['Qn_Num'], null);
      }
      else{
        this.getFiltereData(this.configObject.info && this.configObject.info.pageCurrent ? this.configObject.info.pageCurrent : 1,selected_column['Qn_Num'], null);
      }

    }
    else {
      let ele = document.getElementById('optionsDropdown');
      ele.classList.contains('open') ? ele.classList.remove('open') : '';
      let inpOptions = document.getElementsByName('optionsField');
      for (let option in inpOptions) {
        let ele = <HTMLInputElement>inpOptions[option];
        if (ele.checked) {
          values.push(ele.value);
        }
      }
      this.selectedOption = values[0];
      if(this.selectedSubForm){
        this.getParticularVersionSubForms(selected_column['Qn_Num'], values);
      }
      else{
        this.getFiltereData(this.configObject.info.pageCurrent,selected_column['Qn_Num'], values);
      }
    }
    selected_column = selected_column.Qn;
    values = values;
  }

  public trigger = function ($event) {
    switch ($event.name){
        case 'gt-page-changed-lazy':
            this.getSurveyData(this.selectedQnrService.getQnr(), this.selectedQnrService.getSelectionType());
            break;
        case 'gt-sorting-applied':
            // console.log($event.value);
            break;
        default:
            // console.log($event);
            break;
    }
  };
  public getSurveyDataWithSizeSet = function(value){
    this.noOfRowsAtATime = value;
    let index = this.versions.indexOf(this.selectedVersion)
    if(index > -1)
      this.getParticularVersionQuestions(index);

    if(this.selectedSubForm){
      this.getSubFormData(this.selectedSubForm, null);
    }
    else{
      this.getSurveyData(this.selectedQnrService.getQnr(),this.selectedQnrService.getSelectionType());
    }
  };

  public getAllData = function(){
    this.selectedSubForm = null;
    this.selectedsubformVersion = null;
    this.selectedVersion = null;
    this.getSurveyData(this.selectedQnrService.getQnr(),this.selectedQnrService.getSelectionType());
  }

  public getAllDataWithoutFilters(){
    if(this.selectedSubForm){
      this.getSubFormData(this.selectedSubForm, null);
    }
    else{
      this.getAllData();
    }
  }

  
  selectedQnr;
  public getSurveyData = function (qnr,selectionType) {
    this.selectedQnr = qnr;
    if(qnr.numResponses == 0){
      return;
    }
    this.selectedVersion = null;
    this.noDataForSelectedVersion = false;
    if(qnr.numResponses != 0)
    {
    this.disable_button_map = true;
    this.disable_button = true;
    this.adminID = qnr.adminID;
    this.versions = qnr.versions;
    this.subformVersions = [];
    this.numVersionResponses = qnr.numVersionResponses;
    // this.showLoader = true;
    this.noQnrSelected = false;
    let subFormData ;
    // console.log(qnr);
    if(Boolean(qnr.child_group)){
      subFormData = qnr.child_group;
    }
    else{
      this.selectedQnrService.setSubFormIDS([]);
    }
    this.selectQnr = qnr.surveyName;
    this.selectedQnrService.setQnr(qnr, selectionType);
    // tell generic table instance that we're loading data
    this.myTable ? this.myTable.loading = true : '';
    this.restApiService.getSurveyDataServicePage(qnr.qID, qnr.adminID ,this.configObject.info.pageCurrent,this.noOfRowsAtATime,subFormData, this.searchTerms).subscribe(
      result => {
        Questions = [];
        this.removeFilterSelections();
        this.Questions = [];
        this.subformsIDs = [];
        if (result.success != undefined && result.success != false) {
          this.noDataCollected = false;
          let question = result.question;
          Questions = question;
          this.Questions = question;
          this.subformsIDs =  result.subFormArray;
          // for(let data in result.subFormArray)
          // {
          //   this.subformsIDs.push({id :  result.subFormArray[data]["qID"] , "subFormName" : result.subFormArray[data]['surveyName'], numOfQues : result.subFormArray[data]['question'].length , numResponses : parseInt(result.subFormArray[data]['numResponses'])});
          // }
          this.selectedQnrService.setSubFormIDS(this.subformsIDs);
          this.updateTableData(result,question);
       }
        else {
          this.noDataCollected = true;
          if(result.code == 'SUBSEND'){
            this.subscriptionEndedMessage = "Subscrition Ended";
            this.openUpgradePlanDialog();
          }  
        }
        this.showLoader = false;

      });
    }
    else{
    this.versions = [];
    this.subformVersions = [];
    this.numVersionResponses = [];
    this.noQnrSelected = false;
      this.noDataCollected = true;
      this.selectQnr = qnr.surveyName;
    }
  };

  openVideoDialog(link){
    if(link){
      let dialogRef = this.dialog.open(VideoDialogComponent,{
        data:link,
        height: '70vh',
        width: '80vw'
      })
    }
  }

  openLinkInNewWindow(link){
    if(link != null && link != -1 && link != '-1')
      window.open(link);
  }

  getSubFormData(qnr, id){
    this.noDataForSelectedVersion = false;
    this.disable_button_map = true;
    this.disable_button = true;
    this.noQnrSelected = false;
    this.selectedSubForm = qnr;
    this.subformVersions = qnr.versions;
    this.selectedsubformVersion = undefined;
    this.noDataCollected = false;
    this.selectedQnrService.setSubFormIDS([]);
    let adminId = this.adminID;
    if(id == null){
      adminId = qnr.adminID;
    }
    this.restApiService.getSurveyDataServicePage(qnr.qID, adminId ,this.configObject.info.pageCurrent,this.noOfRowsAtATime,[],this.searchTerms).subscribe(
      result => {
        // console.log(result);
        this.removeFilterSelections();
        Questions = [];
        this.Questions = [];
        if (result.success != false) {
          let question = result.question;
          Questions = question;
          this.Questions = question;
          this.updateTableData(result,question);

          if( id != null)
          {
            this.ConfigOptions.rowSelection = true;
            this.ConfigOptions.rowSelectionInitialState =  row => row['groupID'] === id;
          }
        }
        else {
          this.noDataCollected = true;
          if(result.code == 'SUBSEND'){
            this.subscriptionEndedMessage = "Subscrition Ended";
            this.openUpgradePlanDialog();
          }  
        }
        this.showLoader = false;

      });
  }

  getFiltereData(currentPage, selectedQuesIndex, filterFields) {
    let postparams =  {surveyID: this.selectedQnrService.getQnr().qID, adminID: this.selectedQnrService.getQnr().adminID, page: currentPage, ques: selectedQuesIndex, option: filterFields, operation: -1, numberofrows: this.noOfRowsAtATime, minValue: this.minValue, maxValue: this.maxValue, version : this.selectedVersion && this.selectedVersion != '--all--' && this.selectedVersion != 'Select Version' ? this.selectedVersion : null  };
    postparams['AfterDate'] = this.selectedQnrService.getQnr().updateTime;

    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        this.onFilteredResult(result);
      });
  }

  onFilteredResult(result){
    this.disable_button_map = true;
    this.noDataForSelectedVersion = false;
    this.Questions = [];
    if (result.success != undefined && result.success != false) {
      this.noDataCollected = false;
      this.Questions = result.question;
      for (let i in this.Questions) {
        if (this.Questions[i].Qn_Type == "Map") {
          this.disable_button_map = false;
        }
      }
      this.selectedQnrService.setSubFormIDS(this.subformsIDs);
      this.updateTableData(result,this.Questions);
   }
    else {
      this.noDataCollected = true;
      if(result.code == 'SUBSEND'){
        this.subscriptionEndedMessage = "Subscrition Ended";
        this.openUpgradePlanDialog();
      }  
    }
    this.showLoader = false;
  }

  updateTableData(result,question){
    let fields = [];
    let settings = [];
    settings.push({ objectKey: 'id', visible: true, sort: 'disable',enabled: true, columnOrder: 0 });
    fields.push({
      name: 'S.No',
      objectKey: 'id',
      expand: { component: CustomRowComponent },
      columnClass: 'clickable'
    });

    if(result && result.data && result.data.length>0 && result.data[0].responseID){
      settings.push({objectKey:'responseID',visible:true,sort:'disable',
      search: false})
      fields.push({
        name:'Response ID',
        objectKey:'responseID',
        value: function(row){
          return row.responseID
        }
      })
    }

    let quesColOrderNum = 1;
      fields.push({
        name: 'Surveyor, Date',
        objectKey: 'username',
        value: function(row) {
          return row.username + ' ' + row.profilename;
        },
        columnComponent: {
          type: UserTooltipComponent
        },
        // header: {
        //   type: TableHeaderComponent
        // }
        // render : (row) => {
        //   return '<div style="text-align: center">' + row.profilename + '</div>' +'<div style="background: rgba(0, 150, 136, 0.1);font-weight: 500; \
        //   font-size: 13px; line-height: 15px; text-align: center; color: #000000; padding: 0.5rem;" [ngbTooltip]=\'' + row.username +'\n' + row.profilename + '\'  >' + row.username + '</div>' +'<div style="text-align: center">' + this.datePipe.transform(row.time,'short') + '</div>';
        // }
      });
      settings.push({
        objectKey: 'username',
        visible: true,
        columnOrder: 1,
        sort: 'disable',
        search: true
      });

      settings.push({ objectKey: 'version', visible: true, sort: 'disable',enabled: true, columnOrder: 0 });
      fields.push({
        name: 'Version',
        objectKey: 'version'
      });
      
    for (let i in question) {
      if (question[i].Qn_Type == "Map") {
        this.disable_button_map = false;
      }
      // else
      if (question[i].Qn_Type == "Picture Input") {
        imageQues = question[i].Qn_Num;
      }
      settings.push({
        objectKey: 'c' + question[i].Qn_Num,
        visible: true,
        columnOrder: question[i].Qn_Num + quesColOrderNum ,
        sort: 'disable',
        search: false
      });

      var columnName = question[i].Qn;
       if(question[i].Qn.length > 20)
       {
         columnName = question[i].Qn.substring(0,20)+'...';
       }

      let obj = {
        name: columnName,
        objectKey: 'c' + question[i].Qn_Num
      }
      // adding title to the element or rows 
      obj['render'] = function(row) {
        if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
        {
          // replace all single and double inverted commas into single inverted commas...
          let title_ = row[obj.objectKey].replaceAll('"',"'").replaceAll("''","'");
          return  '<span title="'+ title_ +'">'+ row[obj.objectKey] + '</span>';
        }
        else{
          return '-';
        }
      }
      if (question[i].Qn_Type == "Picture Input") {
        obj['render'] = function(row) {
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            return  '<img style="cursor: pointer;width: 6rem;height: 6rem;" src='+ row[obj.objectKey] +' />';
          }
          else{
            return '-';
          }
        }
        obj['click'] = row => this.openLinkInNewWindow(row[obj.objectKey]);
      }
      if(question[i].Qn_Type == 'Video'){
        obj['render'] = function(row) {
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            return  '<img style="cursor: pointer; " src="../../assets/images/video_response.svg" />';
          }
          else{
            return '-';
          }
        }
        obj['click'] = row => this.openVideoDialog(row[obj.objectKey]);
      }

      if(question[i].Qn_Type == 'Document'){
        obj['render'] = function(row) {
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            let tempTypeArr = row[obj.objectKey].split('.');
            let tempUrlParts =  row[obj.objectKey].split('/');
            let type = tempTypeArr[tempTypeArr.length - 1]; 
            let fileName = tempUrlParts[tempUrlParts.length - 1];
            if(type == 'pdf')
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/pdf_response.png" /><div>'+ fileName + '</div>';
            else if(type == 'doc' || type == 'docx')
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/doc_response.png" /><div>'+ fileName + '</div>';
            else if(type == 'ppt' || type == 'pptx')
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/ppt_response.png" /><div>'+ fileName + '</div>';
            else if(type == 'xls' || type == 'xlsx')
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/excel_response.png" /><div>'+ fileName + '</div>';
            else if(type == 'txt')
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/txt_response.png" /><div>'+ fileName + '</div>';
            else 
              return '<img style="cursor: pointer; width: 4.6rem; display: flex; align-items: center; margin: auto;" src="../../assets/images/default_doc_response.png" /><div>'+ fileName + '</div>';

          }
          else{
            return '-';
          }
        }
        obj['click'] = row => this.openLinkInNewWindow('https://docs.google.com/viewer?url=' + row[obj.objectKey]);
      }

      if(question[i].Qn_Type == 'Audio'){
        obj['render'] = function(row) {
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            return  '<img style="cursor: pointer; " src="../../assets/images/audio_response.svg" />';
          }
          else{
            return '-';
          }
        }
        obj['click'] = row => this.openVideoDialog(row[obj.objectKey]);
      }

      if(question[i].Qn_Type == 'Map'){
        obj['render'] = function(row) {
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            let jsonOfLatLng = JSON.parse(row[obj.objectKey]);
            if (jsonOfLatLng.hasOwnProperty('lat') && jsonOfLatLng.hasOwnProperty('lng')) {
              return '<div>Lat : '+ jsonOfLatLng.lat +'</div>' + '<div>Lng :'+ jsonOfLatLng.lng + '</div>' + '<div style="text-align: center"><img style="cursor: pointer; " src="../../assets/images/location_responses.svg" /></div>';
            }
            else {
              return '-';
            }
          }
          else{
            return '-';
          }
        }
        obj['click'] = row =>{
          if(row[obj.objectKey] != null && row[obj.objectKey] != -1 && row[obj.objectKey] != "-1")
          {
            let jsonOfLatLng = JSON.parse(row[obj.objectKey]);
            if (jsonOfLatLng.hasOwnProperty('lat') && jsonOfLatLng.hasOwnProperty('lng')) {
              this.openLinkInNewWindow('https://www.google.com/maps/search/?api=1&query='+ jsonOfLatLng.lat + ',' + jsonOfLatLng.lng);
            }
          }
        } 
      }
      fields.push(obj);
    }
    // if (imageQues == -1) {
    //   for (let i in result.data) {
    //     imageUrls.push('../../assets/images/user.svg');
    //   }
    // }

    this.configObject.fields = fields;
    this.configObject.settings = settings;
    this.configObject.data = result ? result.data : [];
    if(!(Object.keys(result).length === 0 && result.constructor === Object) ){
      this.configObject.info = <GtInformation>result['paging'];
    }
    this.disable_button = false;
 
  }

  setQuestionForFilter(selectedQues) {
    if (selectedQues.Opt_Name.length != 0) {
        this.optionsArray = selectedQues.Opt_Name;
        this.rangeFilter = false;
        this.optionsFilter = true;
    }
    else if (selectedQues.Qn_Disp_Value == 'Number' && selectedQues.Qn_Type.charAt(0) != 'M') {
        this.rangeFilter = true;
        this.optionsFilter = false;
    }
    else {
        this.optionsArray = [];
    }
    this.selectedOption = 'Select options';
  }

  openChangePlanDialog(){
    let dialogRef = this.dialog.open(ChangePlanModalComponent,{
      width: '52%',
      data: {}
    })
    dialogRef.afterClosed().subscribe(res=>{
      // console.log(res);
    })
  }

  openUpgradePlanDialog(){
    let dialogRef = this.dialog.open(PlanUpgrageDialogComponent,{
      width: '52%',
      data: {}
    })
    dialogRef.afterClosed().subscribe(res=>{
      // console.log(res);
    })
  }

  getQnrList() {

    if(!this.tabsDataService.hasSurveyTabDataTobeUpdated())
    {
      this.qnrList = this.tabsDataService.getSurveyTabData();
    }
    else {
      this.loaderOfDropdown = true;
      this.restApiService.getQnrListService().subscribe(
        result => {
          this.loaderOfDropdown = false;
          this.qnrList = result.result;
        });
    }
  }

  removeFilterSelections(){
    this.selectedQues = 'Select Column';
    this.selectedOption = 'Select Option';
    this.optionsArray = [];
    this.optionsFilter = false;
    this.rangeFilter = false;
    this.minValue = null;
    this.maxValue = null;
  }

  setSelectedVersion(version,indexOfVersion){
    if(this.numVersionResponses[indexOfVersion]!=0){
      this.selectedVersion = version;
    }
  }

  getParticularVersionQuestions(indexOfVersion) {
    this.noDataForSelectedVersion = false;
    this.removeFilterSelections();
    this.getFiltereData(this.configObject.info && this.configObject.info.pageCurrent ? this.configObject.info.pageCurrent : 1, null, null);
    // work for all versions instead of version with responses....
    // if(this.numVersionResponses[indexOfVersion] > 0){
    //   this.noDataForSelectedVersion = false;
    //   this.removeFilterSelections();
    //   this.getFiltereData(this.configObject.info && this.configObject.info.pageCurrent ? this.configObject.info.pageCurrent : 1, null, null);
    // }
    // else{
    //   return;
    //   // this.noDataForSelectedVersion = true;
    //   // this.showToastyService.failure(""," No responses for the version selected");
    //   // "The numVersionResponses indicates that the count ofresponses for this version is zero"
    // }
  }

  getParticularVersionSubForms(ques, option){
    this.noDataForSelectedVersion = false;
    let postparams = { surveyID: this.selectedSubForm.qID, 
      adminID: this.selectedSubForm.adminID, 
      page: this.configObject.info && this.configObject.info.pageCurrent ? this.configObject.info.pageCurrent : 1, 
      ques: ques, option: option, operation: -1, numberofrows: this.noOfRowsAtATime, 
      minValue: this.minValue, maxValue: this.maxValue, version: this.selectedsubformVersion };

    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        this.onFilteredResult(result);
      });
  }

}


@Component({
  selector: 'download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.css']
})
export class DownloadDialogComponent {
  versions = [];
  selectedVersion;
  selectedVersionList = [];
  selectedSurvey;
  subformsIDs=[];
  showLoader : boolean = false;
  numVersionResponses = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  private selectedQnrService: SelectedQnrService, private restApiService: RestApiService,
  public dialogRef: MatDialogRef<MapDialogComponent>, private toastService: ShowToastyService){
    if(this.data){
      this.versions = this.data.versions;
      this.selectedVersion = this.data.selectedVersion;
      if(this.selectedVersion && this.selectedVersion != ""){
        this.selectedVersionList.push(this.selectedVersion);
      }
      this.selectedSurvey = this.data.selectedSurvey;
      this.subformsIDs = this.data.subformsIDs;
      this.numVersionResponses = this.data.numVersionResponses;
    }
  } 

  onSelectVersion(version,index){
    // works for all version instead of version with responses.
    // if(this.numVersionResponses[index]==0){
    //   return;
    // }
    if(!this.selectedVersionList.includes(version)){
      this.selectedVersionList.push(version);
    }
    else{
      if(this.selectedVersion != 'All'){
        this.toastService.failure("","This version has already been added");
      }
    }
  }

  selectAllVersion(){
    let index = 0;
    this.versions.forEach(version=>{
      if(this.numVersionResponses[index]!=0){
        this.onSelectVersion(version,index)
      }
      index = index +1;
    })
  }

  removeVersion(version){
    this.selectedVersionList = this.selectedVersionList.filter(data=> data!= version);
  }

  downloadCsv(){
    this.showLoader = true;
    let qnr = this.selectedQnrService.getQnr();
    let formsList:any[] = [qnr.qID];
    if(Boolean(qnr.child_group)){
      formsList = formsList.concat(qnr.child_group);
    }
    let adminId = [qnr.adminID];
    if(this.subformsIDs){
      adminId = [];
      let newObj: {parentAdminId:string,parentId:string,adminId:string,
      qId:string}[]=[];
      this.subformsIDs.forEach(element => {
        newObj.push({parentAdminId:element.updatedBy, parentId:element.parent_group,
        adminId: element.adminID, qId : element.qID});
      });
      // getting the first element.
      let parentAdded = false;
      formsList.forEach(ids=>{
        newObj.forEach(data=>{
          if(ids== data.parentId && !parentAdded){
            adminId.push(this.selectedQnrService.getQnr().adminID);
            parentAdded = true;
          }
          else if(!adminId.includes(ids) && ids == data.qId){
            adminId.push(data.adminId)
          }
        })
      })
    }
    if(!this.selectedVersionList || this.selectedVersionList.length == 0){
      if(this.versions == null){
        this.getCSV(formsList,adminId,qnr,null);
      }
      else{
        let index = 0;
        let download = 0;
        this.versions.forEach(data=>{
          if(this.numVersionResponses[index] != 0){
            setTimeout(() => {
              this.showLoader = true;
              this.getCSV(formsList,adminId,qnr,data);
            }, 1000);
            download = download + 1;
          }
          index = index +1;
        });
        //  if all of the versions has no value.
        if(download == 0){
          this.getCSV(formsList,adminId,qnr,null);
        }
      }
    }
    else{
      this.selectedVersionList.forEach(data=>{
        setTimeout(() => {
          this.showLoader = true;
          this.getCSV(formsList,adminId,qnr,data);
        }, 1000);
      })
    }
    // getting csvfiles for selected version
  };

  getCSV(formsList,adminId,qnr,version){
    this.restApiService.getExcelFile(formsList,adminId,qnr.surveyName,version).subscribe(
      result => {
        this.showLoader = false;
        let a = document.createElement('a');
        a.href = result;
        a.target = '_blank';
        a.download = 'data.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },error=>{
        this.showLoader = false;
      })
  }


  onClose(){
    this.dialogRef.close();
  }
}

@Component({
  selector: 'map-view',
  templateUrl: 'map-view.html',
  styleUrls: ['./map-view.component.css']
})
export class MapDialogComponent {
  name: any;
  selectedSurveyData: any[];
  datakeys: any[];
  showDetailsflag: boolean;
  showleftPanelLoader: boolean;
  Questions: any[];
  QuestionsData:any[];
  showResponsesFlag: boolean;
  selectedElement: any;
  prevclick: any;
  showMapLoader: boolean;
  center:any;
  zoom: any;
  markerClusterData: any[] = [];
  markerClusterGroup: L.MarkerClusterGroup;


  optionsSpec: {
    layers: any[],
    zoom: number,
    center: number[],
  } = {
      layers: [
        {
          url: 'http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
          maxZoom: 20,
          attribution: 'Map'
        }
      ],
      zoom: 5,
      center: [20.5937, 78.9629]
    };

  layers = [];
  currentPage: number = 1;
  modalScrollDistance = 20;
  // firstQues = firstQues;
  mapLocation = [];
  imageQues = imageQues;
  imageUrls: any[];
  optionsArray: any[];
  selectedQues = 'Select a Question';
  selectedQuesIndex: any;
  filterFields: any[];
  datadialog: any;
  filterON: boolean;
  imageUrl: any;
  tempdata:any;
  displayImage: boolean;
  tempImg : any;
  operation : any;
  value:number;
  rangeFilter:boolean;
  optionsFilter:boolean;
  version;
  unselected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-unselected.svg',
  });
  selected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-selected.svg',
  });

  // options = {
  //   layers: this.optionsSpec.layers.map((l) => {
  //     return L.tileLayer(l.url, { maxZoom: l.maxZoom, attribution: l.attribution });
  //   }),
  //   zoom: this.optionsSpec.zoom,
  //   center: L.latLng(this.optionsSpec.center[0], this.optionsSpec.center[1]),
  //   mapTypeControl: true,
  //   mapTypeControlOptions: {
  //      mapTypeIds: ['roadmap', 'terrain','satellite']
  //   },
  //   mapTypeId: 'terrain'
  // };

  map: L.Map;
  markers: L.Marker[] = [];
  options1 = {
    layers: [
      L.tileLayer('http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        attribution: 'map'
      })
    ],
    zoom: 16,
    center: { lat: 28.626137, lng: 79.821603 }
  };
  initialMarkers: {position: { lat: number, lng: number },
  draggable: false,
  id:string}[] = [];

  initMarkers() {
    for (let index = 0; index < this.initialMarkers.length; index++) {
      const data = this.initialMarkers[index];
      const marker = this.generateMarker(data, index);
      marker.addTo(this.map).setIcon(this.unselected);
      this.map.panTo(data.position);
      this.markers.push(marker)
    }
  }

  generateMarker(data: any, index: number) {
    return L.marker(data.position, { draggable: data.draggable })
      .on('click', (event) => this.markerClicked(event, index))
      .on('dragend', (event) => this.markerDragEnd(event, index));
  }

  onMapReady($event: L.Map) {
    this.map = $event;
    this.initMarkers();
  }

  mapClicked($event: any) {
    console.log($event.latlng.lat, $event.latlng.lng);
  }
  onMapZoom(map: L.Map){
    console.log("zoom",map);
  }

  markerClicked($event: any, index: number) {
    const id= this.initialMarkers[index].id
    const position= this.initialMarkers[index].position;
    this.tempdata = '';
    this.showDetailsflag = false;
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = $event;
    $event.target.setIcon(this.selected);
    this.restApiService.getSurveyDataForID(this.selectedQnrService.getQnr().qID, this.selectedQnrService.getQnr().adminID,id).subscribe(
      result => {
        this.tempdata = result.data[0];
        if (result.data[0]['c' + this.imageQues]) {
          this.tempImg = result.data[0]['c' +this.imageQues];
        }
        else {
          this.tempImg ='../../assets/images/user.svg';
        }
        this.chRef.detectChanges();
        // var element = document.getElementById('data');
        // element.scrollIntoView();
       this.showTempDetails(0);
      });
  }

  markerDragEnd($event: any, index: number) {
    console.log($event.target.getLatLng());
  } 


  constructor(private chRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<MapDialogComponent>, public restApiService: RestApiService, private selectedQnrService: SelectedQnrService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.showResponsesFlag = true;
    this.selectedQuesIndex = -1;
    this.Questions = [];
    this.QuestionsData=[];
    this.showDetailsflag = showDetails;
    this.selectedSurveyData = [];
    this.filterFields = [];
    this.filterON = false;
    this.imageUrls = [];
    this.displayImage = false;
    this.tempdata = '';
    this.showleftPanelLoader = true;
    this.showMapLoader = true;
    this.center= [20.5937, 78.9629];
    this.zoom = 5;
    this.operation = -1;
    this.value= -1;
    this.rangeFilter= false;
    this.optionsFilter = false;
    this.version = data;
    let postparams =  {version : this.version, surveyID: this.selectedQnrService.getQnr().qID, 
      adminID: this.selectedQnrService.getQnr().adminID, page: this.currentPage, 
      ques: this.selectedQuesIndex, option: this.filterFields, operation: this.operation, 
      numberofrows: null, minValue: null, maxValue: null ,is_small:true};
    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        Questions = [];
        if (result.data != false) {
          let question = result.question;
          Questions = question;
          // firstQues = question[0].S_Qn;
          let data = result.data;
          surveyData = result.data;
          let errorQuestions = [];
          let mapLocation = [];
          for (let i in data) {
            // if (typeof (data[i][locationQues]) == 'string' && data[i][locationQues] != -1) {
              let mapLocationValue = [];
              let loationValue = JSON.stringify({"lat":parseFloat(data[i]["latitude"]),"lng":parseFloat(data[i]["longitude"])});
              if (/^[\],:{}\s]*$/.test(loationValue.replace(/\\["\\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
                  if(JSON.parse(loationValue).lat != null && JSON.parse(loationValue).lng != null)
                  {
                    mapLocationValue.push(JSON.parse(loationValue).lat);
                    mapLocationValue.push(JSON.parse(loationValue).lng);
                    mapLocation.push({'value': mapLocationValue, 'id' : data[i]['id']});
                  }
              }
              else {
                errorQuestions.push(surveyData.indexOf(data[i]));
              }
            // }
            // else {
            //   errorQuestions.push(surveyData.indexOf(data[i]));
            // }
          }
          this.mapLocation = mapLocation;
          this.markerClusterData = [];
          this.initialMarkers = [];
          for (let i in this.mapLocation) {
            this.initialMarkers.push({position: {lat: this.mapLocation[i].value[0], lng: this.mapLocation[i].value[1]},
              draggable:false, id: this.mapLocation[i].id});
            this.markerClusterData.push(L.marker(this.mapLocation[i].value,{'id': this.mapLocation[i].id}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
          }
          this.showMapLoader = false ;
          for (var q = errorQuestions.length - 1; q > -1; q--) {
            surveyData.splice(surveyData.indexOf(data[errorQuestions[q]]), 1);
          }
          this.datadialog = surveyData;
          this.Questions = Questions;
          for (let i in Questions) {
            this.QuestionsData.push(Questions[i].Qn);
          }
          this.QuestionsData.push("Time when the surve was synced");
          this.QuestionsData.push("Surveyor");
          this.QuestionsData.push("Surveyor Name");
          this.QuestionsData.push("Latitude");
          this.QuestionsData.push("Longitude");
        //   if(this.imageQues == -1)
        //   {
        //     console.log("NO IMAGE QUESTION");
        //   }
        //   else
        //   {
        //   for (let i in this.datadialog) {
        //     if (this.datadialog[i]['c' + this.imageQues]) {
        //       this.imageUrls.push(this.datadialog[i]['c' + this.imageQues]);
        //     }
        //     else {
        //       this.imageUrls.push('../../assets/images/user.svg');
        //     }
        //   }
        // }
          this.showleftPanelLoader=false;
        }
        else {
          this.showleftPanelLoader = true;
        }
        this.showMapLoader = false;
      },
      error=>{
        this.showMapLoader= false;
      });
  }
  ngOnInit() {
  }

  markerClusterReady(group: L.MarkerClusterGroup) {
    this.markerClusterGroup = group;
    let lat1, lng1;
    this.markerClusterGroup.options.iconCreateFunction = function (cluster) {
      return L.divIcon({ html: '<b style="padding:4px; background-color: #FFA17A; text-align: center;font-size: 12px; border-radius:50%; color:#FFFFFF"; font-weight: 500;font-family: "Roboto";font-style: normal;line-height: 14px;">' + cluster.getChildCount() + '</b>', className: 'my-div-icon', iconSize: L.point(40, 40),
      iconAnchor: L.point(7, 12) });
    }
    this.markerClusterGroup.options.maxClusterRadius = 10;
    this.markerClusterGroup.options.singleMarkerMode = true;
  }


  onclick = (e) => {
    if(this.previousMarker){
      this.map.removeLayer(this.previousMarker);
    }
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = e;
    e.target.setIcon(this.selected);

    this.tempdata = '';
    this.showDetailsflag = false;
    this.restApiService.getSurveyDataForID(this.selectedQnrService.getQnr().qID, this.selectedQnrService.getQnr().adminID,e.target.options.id).subscribe(
      result => {
        this.tempdata = result.data[0];
        if (result.data[0]['c' + this.imageQues]) {
          this.tempImg = result.data[0]['c' +this.imageQues];
        }
        else {
          this.tempImg ='../../assets/images/user.svg';
        }
        this.showTempDetails(0);
        this.chRef.detectChanges();
        // var element = document.getElementById('data');
        // element.scrollIntoView();
      });
    // for (let i in this.datadialog) {
    //   var values = JSON.parse(this.datadialog[i][locationQues]);
    //   console.log(values);

    //   if (e.latlng.lat == values.lat && e.latlng.lng == values.lng || Math.abs(e.latlng.lat - values.lat) < 0.0001 && Math.abs(e.latlng.lng - values.lng) < 0.0001) {

    //     var element = document.getElementById(i);
    //     element.scrollIntoView();
    //     element.classList.add('selectedElement');
    //   }
    // }
  };
  showTempDetails(data) {
    // for (let i in this.tempdata) {
    //   if (document.getElementById(i).classList.contains('selectedElement')) {
    //     document.getElementById(i).classList.remove('selectedElement');
    //   }
    // }
    this.selectedSurveyData = this.tempdata;
    this.datakeys = Object.keys(this.selectedSurveyData);
    if (this.selectedSurveyData['c' + imageQues]) {
      this.imageUrl = this.selectedSurveyData['c' + imageQues];
      this.displayImage = true;
    }
    else {
      this.displayImage = false;
    }
    this.datakeys.splice(0, 1);
    this.chRef.detectChanges();
  }

  previousMarker:any;
  showDetails(data) {
    this.showDetailsflag = false;
    // this.selectedSurveyData = this.datadialog[data];
    // this.datakeys = Object.keys(this.selectedSurveyData);
    // if(this.selectedSurveyData["latitude"] != null && this.selectedSurveyData["longitude"] != null)
    // {
    //   this.zoom = 18;
    //   this.center= [parseFloat(this.selectedSurveyData["latitude"]),parseFloat(this.selectedSurveyData["longitude"])];
    // }
    // if (this.selectedSurveyData['c' + imageQues]) {
    //   this.imageUrl = this.selectedSurveyData['c' + imageQues];
    //   this.displayImage = true;
    // }
    // else {
    //   this.displayImage = false;
    // }
    // this.datakeys.splice(0, 2);
    let postparams =  {version : this.version, surveyID: this.selectedQnrService.getQnr().qID, 
      adminID: this.selectedQnrService.getQnr().adminID, page: this.currentPage, 
      ques: this.selectedQuesIndex, option: this.filterFields, operation: this.operation, 
      numberofrows: null, minValue: null, maxValue: null,  id:this.datadialog[data].id};
    this.restApiService.getSurveyDataWithDetails(postparams).subscribe(result=>{
      if(result && result.success){
        const Questions = result.question;
        this.Questions = Questions;
        for (let i in Questions) {
          this.QuestionsData.push(Questions[i].Qn);
        }
        this.QuestionsData.push("Time when the surve was synced");
        this.QuestionsData.push("Surveyor");
        this.QuestionsData.push("Surveyor Name");
        this.QuestionsData.push("Latitude");
        this.QuestionsData.push("Longitude");
        this.selectedSurveyData = result.data[0];
        this.datakeys = Object.keys(this.selectedSurveyData);
        if(this.selectedSurveyData["latitude"] != null && this.selectedSurveyData["longitude"] != null)
        {
          this.zoom = 18;
          this.center= [parseFloat(this.selectedSurveyData["latitude"]),parseFloat(this.selectedSurveyData["longitude"])];
        }
        if(this.previousMarker){
          this.map.removeLayer(this.previousMarker);
        }
        this.previousMarker = L.marker([parseFloat(this.selectedSurveyData["latitude"]),parseFloat(this.selectedSurveyData["longitude"])]);
        this.previousMarker.addTo(this.map).setIcon(this.selected);
        if (this.selectedSurveyData['c' + imageQues]) {
          this.imageUrl = this.selectedSurveyData['c' + imageQues];
          this.displayImage = true;
        }
        else {
          this.displayImage = false;
        }
        this.datakeys.splice(0, 1);
      }
    })
  }
  hidedetails() {
    this.showDetailsflag = true;
    if(this.previousMarker){
      this.map.removeLayer(this.previousMarker);
    }
    // this.zoom = 10;
  }
  getQuesDetails(data) {
    this.filterON = true;
    this.selectedQuesIndex = Questions[data].Qn_Num;
    this.selectedQues = Questions[data].Qn;
    this.filterFields=[];
    if (Questions[data].Opt_Name.length != 0) {
      this.optionsArray = Questions[data].Opt_Name;
      this.operation = -1;
      this.rangeFilter = false;
      this.optionsFilter = true;
    }
    else if(Questions[data].Qn_Disp_Value=='Number'){
      this.rangeFilter = true;
      this.optionsFilter= false;
    }
    else{
      this.optionsArray = [];
    }
  }
  showResponses() {
    this.showResponsesFlag = true;
    this.filterFields = [];
  }
  operationFunc(data)
  {
    this.operation= data;
  }
  showFilters() {
    this.filterFields = [];
    this.showResponsesFlag = !this.showResponsesFlag;
  }
  fieldsToFilter(data) {
    if (this.filterFields.indexOf(data) < 0) {
      this.filterFields.push(data);
    }
    else {
      this.filterFields.splice(this.filterFields.indexOf(data), 1);
    }
  }
  onApply() {
    this.currentPage  = 1;
    surveyData= [];
    this.mapLocation = [] ;
    if(this.operation!=-1)
    {
    this.filterFields.push(this.value);
    }
    let postparams =  {version : this.version, surveyID: this.selectedQnrService.getQnr().qID, 
      adminID: this.selectedQnrService.getQnr().adminID, page: this.currentPage, 
      ques: this.selectedQuesIndex, option: this.filterFields, operation: this.operation, 
      numberofrows: null, minValue: null, maxValue: null , is_small:true};
    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        if (result.success != false) {
          let question = result.question;
          let data = result.data;
          let errorQuestions = [];
          let mapLocation = [];
          surveyData = result.data;
          for (let i in data) {
            // if (typeof (data[i][locationQues]) == 'string' && data[i][locationQues] != -1) {
              let mapLocationValue = [];
              let loationValue = JSON.stringify({"lat":parseFloat(data[i]["latitude"]),"lng":parseFloat(data[i]["longitude"])});
              // if(typeof (JSON.parse(data[i][locationQues]) == 'object'))
              if (/^[\],:{}\s]*$/.test(loationValue.replace(/\\["\\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
                  if(JSON.parse(loationValue).lat != null && JSON.parse(loationValue).lng != null)
                  {
                    mapLocationValue.push(JSON.parse(loationValue).lat);
                    mapLocationValue.push(JSON.parse(loationValue).lng);
                    mapLocation.push({'value': mapLocationValue, 'id' : data[i]['id']});
                  }
              }
              else {
                errorQuestions.push(surveyData.indexOf(data[i]));
              }
            // }
            // else {
            //   errorQuestions.push(surveyData.indexOf(data[i]));
            // }
          }
          this.mapLocation = mapLocation;
          this.markerClusterData = [];
          for (let i in this.mapLocation) {
            this.markerClusterData.push(L.marker(this.mapLocation[i].value,{'id': this.mapLocation[i].id}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
          }
          for (var q = errorQuestions.length - 1; q > -1; q--) {
            surveyData.splice(surveyData.indexOf(data[errorQuestions[q]]), 1);
          }
          this.datadialog = surveyData;
          for (let i in this.datadialog) {
            if (this.datadialog[i]['c' + this.imageQues]) {
              this.imageUrls.push(this.datadialog[i]['c' + this.imageQues]);
            }
            else {
              this.imageUrls.push('../../assets/images/user.svg');
            }
          }
        }
        else {
          console.log('no data');
        }
      });
    // this.showResponses();
  }
  
  show : string = "show";

  previewToggleClicked(noUse : string){
    if(this.show == 'show'){
      this.show = 'hide';
    }else{
      this.show = 'show';
    }
  }

  onModalScrollDown() {
    this.currentPage ++;
    let postparams =  {version : this.version, surveyID: this.selectedQnrService.getQnr().qID, 
      adminID: this.selectedQnrService.getQnr().adminID, page: this.currentPage, 
      ques: this.selectedQuesIndex, option: this.filterFields, operation: this.operation, 
      numberofrows: null, minValue: null, maxValue: null , is_small:true};
    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        if (result.data) {
          let question = result.question;
          // firstQues = question[0].S_Qn;
          let data = result.data;
          let errorQuestions = [];
          let mapLocation = []
          for (let i in data) {
            // if (typeof (data[i][locationQues]) == 'string' && data[i][locationQues] != -1) {
              let mapLocationValue = [];
              let loationValue = JSON.stringify({"lat":parseFloat(data[i]["latitude"]),"lng":parseFloat(data[i]["longitude"])});
              // if(typeof (JSON.parse(data[i][locationQues]) == 'object'))
              if (/^[\],:{}\s]*$/.test(loationValue.replace(/\\["\\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
                this.datadialog.push(result.data[i]);
              }
              else {
                errorQuestions.push(surveyData.indexOf(data[i]));
              }
            // }
            // else {
            //   errorQuestions.push(surveyData.indexOf(data[i]));
            // }
          }
          for (let i in this.datadialog) {
            if (this.datadialog[i]['c' + this.imageQues]) {
              this.imageUrls.push(this.datadialog[i]['c' + this.imageQues]);
            }
            else {
              this.imageUrls.push('../../assets/images/user.svg');
            }
          }
        }
        else {
          console.log('no data');
        }
      });
  }
  questionFilter(Question){
    if(Question.Qn_Disp_Value=='Number'||Question.Opt_Name.length>0)
    {
      return true;
    }
    else{
      return false;
    }
  }

  onClose(){
    this.dialogRef.close();
  }
  onReset() {
    this.showResponsesFlag = true;
    this.rangeFilter = false;
    this.optionsFilter = false;
    this.selectedQuesIndex = -1;
    this.value = -1;
    this.selectedQues = 'Select a Question';
    this.optionsArray = [];
    this.filterON = false;
    this.currentPage = 1;
    this.datadialog = [];
    this.operation = -1;
    let postparams =  {version : this.version, surveyID: this.selectedQnrService.getQnr().qID, 
      adminID: this.selectedQnrService.getQnr().adminID, page: this.currentPage, 
      ques: this.selectedQuesIndex, option: this.filterFields, operation: this.operation, 
      numberofrows: null, minValue: null, maxValue: null, is_small:true };
    this.restApiService.getSurveyDataServicePageWithFilter(postparams).subscribe(
      result => {
        Questions = [];
        if (result.success != false) {
          let question = result.question;
          Questions = question;
          // firstQues = question[0].S_Qn;
          let data = result.data;
          surveyData = result.data;
          let errorQuestions = [];
          let mapLocation = [];
          for (let i in data) {
            // if (typeof (data[i][locationQues]) == 'string' && data[i][locationQues] != -1) {
              let mapLocationValue = [];
              let loationValue = JSON.stringify({"lat":parseFloat(data[i]["latitude"]),"lng":parseFloat(data[i]["longitude"])});
              // if(typeof (JSON.parse(data[i][locationQues]) == 'object'))
              if (/^[\],:{}\s]*$/.test(loationValue.replace(/\\["\\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
                  if(JSON.parse(loationValue).lat != null && JSON.parse(loationValue).lng != null)
                  {
                    mapLocationValue.push(JSON.parse(loationValue).lat);
                    mapLocationValue.push(JSON.parse(loationValue).lng);
                    mapLocation.push({'value': mapLocationValue, 'id' : data[i]['id']});
                  }
              }
              else {
                errorQuestions.push(surveyData.indexOf(data[i]));
              }
            // }
            // else {
            //   errorQuestions.push(surveyData.indexOf(data[i]));
            // }
          }
          this.mapLocation = mapLocation;
          this.markerClusterData = [];
          for (let i in this.mapLocation) {
            this.markerClusterData.push(L.marker(this.mapLocation[i].value,{'id': this.mapLocation[i].id}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
          }
          for (var q = errorQuestions.length - 1; q > -1; q--) {
            surveyData.splice(surveyData.indexOf(data[errorQuestions[q]]), 1);
          }
          this.datadialog = surveyData;
          this.Questions = Questions;
          for (let i in this.datadialog) {
            if (this.datadialog[i]['c' + this.imageQues]) {
              this.imageUrls.push(this.datadialog[i]['c' + this.imageQues]);
            }
            else {
              this.imageUrls.push('../../assets/images/user.svg');
            }
          }
        }
        else {
          console.log('no data');
        }
      });
  }

  transformDate(date){
    return this.restApiService.transformDate1(date);
  }
}

export interface PeriodicElement {
  sno: string;
  version: string;
  date: string;
  surveyor: string;
}


// WEBPACK FOOTER //
// ./src/app/data-surveys/data-surveys.component.ts